export const normalizePhoneNumber = (phone?: string | null) =>
  phone?.replace(/\D/g, "") ?? "";

export const isEmptyPhoneNumber = (phone?: string | null) => {
  if (!phone || phone === "" || phone === " " || phone.length === 0)
    return true;

  return false;
};

export const isValidBrazilianPhoneNumber = (phone?: string | null) => {
  const normalizedPhone = normalizePhoneNumber(phone);

  return normalizedPhone === "" || /^\d{10,11}$/.test(normalizedPhone);
};
